import React from "react";
import { useNavigate, useLocation } from "react-router";
import { Tabs, TabsList, TabsTrigger } from "@exiftrator/shared/components/ui";
import { useBasePath } from "../../contexts/BasePathContext";
import { useIsMobile, useIsTablet } from "../../hooks/useMobile";
import {
  DESKTOP_WORKSPACE_ORDER,
  WORKSPACE_VIEW_META,
} from "../Workspace/workspaceViewMeta";

export function ViewToggle() {
  const navigate = useNavigate();
  const location = useLocation();
  const { appPath, stripBase } = useBasePath();
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  // Derive current tab value from location pathname
  // Returns empty string for settings so no tab is active
  const getTabValue = (pathname) => {
    const p = stripBase(pathname);
    if (p.startsWith("/settings")) return "";
    if (p === "/table") return "table";
    if (p === "/timeline-v3") return "timelineV3";
    if (p === "/calendar") return "calendar";
    return "editor";
  };

  const viewMode = getTabValue(location.pathname);

  const handleValueChange = (val) => {
    if (val) {
      const path = val === "timelineV3" ? "/timeline-v3" : "/" + val;
      navigate(appPath(path));
    }
  };

  // On mobile, hide Table view entirely
  const showTable = !isMobile;
  // Timeline is desktop/tablet only (mobile redirects to /calendar)
  const showTimeline = !isMobile;
  // Icon-only mode on mobile and tablet
  const iconOnly = isMobile || isTablet;
  const visibleWorkspaces = DESKTOP_WORKSPACE_ORDER.filter((workspaceId) => {
    if (workspaceId === "table") return showTable;
    if (workspaceId === "timelineV3") {
      return showTimeline;
    }
    return true;
  });

  return (
    <Tabs
      value={viewMode}
      onValueChange={handleValueChange}
      activationMode="manual"
    >
      <TabsList variant="line" loop={false}>
        {visibleWorkspaces.map((workspaceId) => {
          const { label, icon: Icon } = WORKSPACE_VIEW_META[workspaceId];

          return (
            <TabsTrigger key={workspaceId} value={workspaceId}>
              <Icon className="size-4" />
              {!iconOnly && <span>{label}</span>}
            </TabsTrigger>
          );
        })}
      </TabsList>
    </Tabs>
  );
}
